<!-- FILE / FOLDER INFO PANEL STARTS - DESKTOP --->
<div class="file-info-panel-main add-people-panel private-share-panel modal-popup" [ngStyle]="{'display': showShareWithPeople ? 'block' : 'none'}">
  <header>
    <div class="mini-thumb-details border-0 pb-1 pseudo-mini-thumb-details">
      <!--<span data-brackets-id="18680" class="float-left"><img data-brackets-id="18681" src="images/mini-thumb.jpg"></span>-->
      <span class="float-left pt-3 d-none d-lg-block">
        Private Share
      </span>
      <!-- Mobile -->
      <span class="d-lg-none float-left pt-3 m-head-txt" (click)="confirmDiscard()">
        <span class="NeueExit-Folder mr-0"></span>Private Share
      </span>
      <!-- Close Icon -->
      <div class="icon-close float-right mt-3 d-none d-lg-block" title="Close Panel" (click)="confirmDiscard()">esc<span class="Neueclosefilled pl-1"></span></div>
      <!-- Owned By -->
      <div class="owned-by"><span>Owned by {{ownerDetail}}</span>
    </div>
  </div>
</header>
<!-- ADD PEOPLE Section starts -->
<div class="add-people-main mt-lg-2">
  <!-- Email chips -->
  @if (isLoggedInUserAllowedToEdit) {
    <div class="email-chips-main pseudo-email-chips-main">
      <!-- Add People -->
      @if (!universalService.showFileInfo && openSourceComponent != "fileinfo") {
        <div class="add-people-inpt-wrap">
          <div class="row ml-0 mt-0 mr-0 mb-0 pl-0 pt-0 pr-0 pb-0">
            <div class="col-lg-12 pl-0 pt-0 pr-0 pb-0" [ngStyle]="{'min-width':implRef.selectedContact.length > 0? '' : '100%'}">
              <!--  -->
              <div class="scrollable-chips">
                <span class="to">
                  <span class="NeueDuplicates ml-3"></span>
                </span>
                <!-- <span class="Neueaddcontactfilled d-lg-none"></span> -->
                @if ( this.universalService.showFeaturesForEntUsers == true  && this.universalService.isAllowEnternalPrivateShare == true) {
                  <input #emailId type="text" id="contact-input" class="mt-1 m-inpt" tabindex="0" placeholder="Add people" (keyup)="onAddingRecipient()" (input)="addNewRecipientMobile($event,emailId.value)" (keydown)="addNewRecipientDesktop($event,emailId.value)" (keydown.enter)="addNewRecipientMobile($event,emailId.value)" [formControl]="contactControl">
                }
                @if (this.universalService.isAllowEnternalPrivateShare == false) {
                  <input #emailId type="text" id="contact-input" class="mt-1 m-inpt" tabindex="0" placeholder="Add people (email)" (keyup)="onAddingRecipient()" (input)="addNewRecipientMobile($event,emailId.value)" (keydown)="addNewRecipientDesktop($event,emailId.value)" (keydown.enter)="addNewRecipientMobile($event,emailId.value)" [formControl]="contactControl">
                }
                <div class="add-people-block">
                  <!-- Email Suggestion -->
                  @if (userData.jcEntInfo && suggestedContactList.length > 0) {
                    <div class="ent-email-suggest">
                      <ul>
                        @for (contact of suggestedContactList; track contact; let i = $index) {
                          <li (click)="getSelectedContact(contact.emailId)" id="{{contact.emailId}}">
                            <div class="dp members-src-list">
                              <div class="icon-profile-holder NeueUserFilled mr-2 mem-dp"></div>
                              <div title="{{contact.firstName}} {{contact.lastName}} ({{contact.emailId}})">
                                <span class="member-item">{{contact.firstName}} {{contact.lastName}} </span>
                                <span>&nbsp;({{contact.emailId}})</span>
                              </div>
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                  @if (!userData.jcEntInfo && suggestedContactList.length > 0) {
                    <div class="email-suggest">
                      <ul>
                        @for (contact of suggestedContactList; track contact; let i = $index) {
                          <li (click)="getSelectedContact(contact)" id="{{contact}}">
                            <div class="dp">
                              <span class="icon-profile-holder NeueUserFilled mr-2 mem-dp"></span>
                              <span class="elipse">{{contact}}</span>
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="inputError mt-2">
          @if (implRef.mailError.error!='' ) {
            <span><i class="NeueAlert mr-1"></i> {{implRef.mailError.error}}</span>
          }
        </div>
        <div class="input-note mt-2">
          @if (implRef.mailError.error=='' && this.universalService.showFeaturesForEntUsers == true  && this.universalService.isAllowEnternalPrivateShare == true) {
            <span>Note: To include one or multiple users, press the space, comma, or {{this.universalService.browserDetails.os.name == "macOS"? 'return':'enter'}} key.</span>
          }
          @if (implRef.mailError.error=='' && this.universalService.showFeaturesForEntUsers == false  && this.universalService.isAllowEnternalPrivateShare == false) {
            <span>Note: To include one or multiple email IDs, press the space, comma, or {{this.universalService.browserDetails.os.name == "macOS"? 'return':'enter'}} key.</span>
          }
        </div>
      }
      </div>
  }
  <!-- Manage People Access -->
  <div class="manage-ppl-access">
    <div class="accordion" id="accordionExample">

      <div class="card">
        @if (implRef.sharedWithNamesLink == 'Not Shared yet') {
          <div class="card-head pseudo-card-head" id="manageAccess">
            <h2 class="mb-0" data-toggle="collapse" data-target="#collapseOne">
              Not Shared Yet
            </h2>
          </div>
        }
        @if (implRef.sharedWithNamesLink != 'Not Shared yet') {
          <div class="card-head pseudo-card-head" id="manageAccess">
            <h2 class="mb-0 collapsed" data-toggle="collapse" data-target="#collapseOne" (click)="setHeightForPeopleContainer()">
              Manage access ({{implRef.displayList?.length}} people added)
              <span class="NeueDropdown_Active mr-2 mt-1"></span>
              <span class="NeueDropdown_Inactive mr-2 mt-1"></span>
            </h2>
          </div>
        }

        @if (implRef.sharedWithNamesLink != 'Not Shared yet') {
          <div id="collapseOne" class="collapse" role="button" aria-labelledby="manageAccess" data-parent="#accordionExample">
            <div class="card-body manage-ppl-email-ids">
              @for (recipient of implRef.displayList; track recipient; let i = $index) {
                <div class="ppl-list" id="{{recipient.recipientKey? recipient.recipientKey : i}}">
                  <div class="row m-0 mb-1 p-0 pt-2 pb-2" [ngClass]="[recipient.isNewRecipient ? 'added' : '']">
                    <div class="col-8 p-0">
                      <div class="dp">
                        <span class="icon-profile-holder NeueUserFilled mr-1 mem-dp"></span>
                        @if (recipient.recipientProfilePic != undefined) {
                          <img [ngStyle]="{'background-size':'100%','background-image': attachKeysToPhoto(recipient.recipientProfilePic)}" class="img-fluid" alt="" />
                        }
                      </div>
                      <span class="member-email">{{(recipient.firstName == undefined) ? recipient.recipientId :recipient.firstName}}&nbsp;{{recipient.lastName}}</span>
                    </div>
                    <div class="col-4 p-0 pr-1 text-right">
                      <div class="dropdown m-0 p-0">
                        @if (this.universalService.selectedFile?.shareKey) {
                          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" [disabled]="recipient.isLoggedInUser || (!isLoggedInUserAllowedToEdit)">
                            {{getRoleNameFromCode(recipient.recipientRole)}}<span class="chevron"></span>
                          </button>
                        }
                        @if (!this.universalService.selectedFile?.shareKey) {
                          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true">
                            {{getRoleNameFromCode(recipient.recipientRole)}}<span class="chevron"></span>
                          </button>
                        }
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" (click)="explicitUserPermission($event, recipient.recipientId, recipient.recipientKey,recipient)">
                          <a class="dropdown-item" href="javascript:void(0);" rel="noopener noreferrer" [attr.data-access-role]="userAccessRole[0]"><span class="NeuePassword-Show mr-3"></span>Can View @if (userAccessRole[0] == recipient.recipientRole) {
                          <span class="NeueCheck ml-3 mt-0"></span>
                        }</a>
                        <a class="dropdown-item" href="javascript:void(0);" rel="noopener noreferrer" [attr.data-access-role]="userAccessRole[1]"><span class="Neueedit_filled mr-3"></span>Can Edit@if (userAccessRole[1] == recipient.recipientRole) {
                        <span class="NeueCheck ml-3 mt-0"></span>
                      }</a>
                      <a class="dropdown-item" href="javascript:void(0);" rel="noopener noreferrer" [attr.data-access-role]="userAccessRole[2]"><span class="Neueremove-filled mr-3"></span>Remove Access@if (userAccessRole[2] == recipient.recipientRole) {
                      <span class="NeueCheck ml-3 mt-0"></span>
                    }</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

</div>
</div>


@if (isLoggedInUserAllowedToEdit) {
  <footer class="private-share-panel-footer pseudo-private-share-panel-footer">
    <!-- Private Message Box -->
    @if (!universalService.showFileInfo) {
      <div class="private-message-box">
        <textarea #senderMessage id="senderMessage" maxlength="200" name="senderMessage" placeholder="Message" (keyup)="validateComments(senderMessage)" tabindex="-1" [disabled]="!universalService.isAnyChange || implRef.invalidEmailIDorNum.length>0" [(ngModel)]="implRef.shareMessage"></textarea>
      </div>
    }
    <!-- Button -->
    <div class="btn-wrap">
      <button class="btn" [disabled]="!universalService.isAnyChange || implRef.invalidEmailIDorNum.length>0" (click)="sendCollabShareLinkToSelectedRecipients()">Save</button>
    </div>
  </footer>
}
</div>
<!-- ADD PEOPLE Section ends -->


<div class="spinner_loader">
  <div class="small_loader"></div>
</div>

</div>
<!-- FILE INFO PANEL ENDS --->